import { CompleteVerification } from "./pages/CompleteVerification";
import { Home, ErrorPage, NotFound } from "./pages/Home";
import { Login } from "./pages/Login";
import { Recovery } from "./pages/Recovery";
import { Registration } from "./pages/Registration";
import { Settings } from "./pages/Settings";
import { Verification } from "./pages/Verification";
import { useLocation } from "./lib/router";

export function App() {
  const { path, query } = useLocation();
  // Keyed on the path so each page starts clean; a ?flow= change within a page is the page's own business.
  switch (path) {
    case "/":
    case "/welcome":
      return <Home key={path} />;
    case "/login":
      return <Login key={path} query={query} />;
    case "/registration":
      return <Registration key={path} query={query} />;
    case "/verification":
      return <Verification key={path} query={query} />;
    case "/recovery":
      return <Recovery key={path} query={query} />;
    case "/settings":
      return <Settings key={path} query={query} />;
    case "/error":
      return <ErrorPage key={path} query={query} />;
    default:
      if (path.startsWith("/complete-verification-")) {
        const slug = path.slice("/complete-verification-".length);
        return <CompleteVerification key={path} slug={slug} />;
      }
      return <NotFound />;
  }
}
